import { render } from "./catalog.vue?vue&type=template&id=f12d5d84&scoped=true"
import script from "./catalog.vue?vue&type=script&lang=js"
export * from "./catalog.vue?vue&type=script&lang=js"

import "./catalog.vue?vue&type=style&index=0&id=f12d5d84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f12d5d84"]])

export default __exports__